
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.1","height":"22.1","viewBox":"0 0 22.1 22.1"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.05)"}},[_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"-110.067","y1":"133.189","x2":"-109.112","y2":"134.181","gradientTransform":"matrix(19.698 0 0 -19.698 2169.905 2644.087)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#eb5c2b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#da1c5c"}})]),_c('path',{attrs:{"fill":"url(#a)","d":"M19 11.6h-8.6V3c0-.3-.3-.6-.6-.6C4.4 2.4 0 6.8 0 12.2S4.4 22 9.9 22c5.4 0 9.8-4.4 9.8-9.8-.1-.3-.3-.6-.7-.6zm-9.2 9.2c-4.7 0-8.6-3.9-8.6-8.6 0-4.5 3.5-8.2 7.9-8.5v8.6c0 .3.3.6.6.6h8.6c-.3 4.4-4 7.9-8.5 7.9z"}}),_c('linearGradient',{attrs:{"id":"b","gradientUnits":"userSpaceOnUse","x1":"-105.893","y1":"126.953","x2":"-104.097","y2":"128.819","gradientTransform":"matrix(10.475 0 0 -10.474 1111.163 1350.36)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#eb5c2b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#da1c5c"}})]),_c('path',{attrs:{"fill":"url(#b)","d":"M22 9.8C22 4.4 17.6 0 12.2 0c-.3 0-.6.3-.6.6v9.2c0 .3.3.6.6.6h9.2c.3.1.6-.2.6-.6 0 .1 0 .1 0 0zm-9.2-.6V1.3c4.3.3 7.6 3.7 8 7.9h-8z"}})])])
          )
        }
      }
    